export default __webpack_public_path__ + "static/special-folder-m-9941a29377cb03b4049f3c5898da324e.webp";